import axios from 'axios';
import { Dispatch } from 'redux';
import { ActionType } from '../Actions/ActionTypes';
import { random } from '../../../../../../config/api';
import FilterDto from '../../../../../../dto/FilterDto';

function fetchMoshaveran() {

    return axios.get(random)
}

export const actionFetchMoshaveran = () => {

    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.MOSHAVERAN_LOAGING })
        fetchMoshaveran().then((res) => {
            dispatch({ type: ActionType.MOSHAVERAN_DATA, data: res.data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.MOSHAVERAN_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.MOSHAVERAN_ERROR, message: err.response.data.error })
            }
        })
    }
}
